import {
  IdashboardFilters,
  IinitialStateServerMap,
} from "../pages/Dashboard/Dashboard.type";
import {FEATURE_CLUSTER_BATTERY_METRIC_ENABLED} from "../config/featureFlags";
import {normalizeBattery} from "../helper/batteryMaturity";

export const getFilteredData = (
  dataServer: IinitialStateServerMap,
  filters: IdashboardFilters
) => {
  if (dataServer?.clusters) {
    const filteredClusters = dataServer?.clusters.filter((cluster) => {
      let isFiltered = true;

      Object.keys(filters).forEach((key) => {
        if (!FEATURE_CLUSTER_BATTERY_METRIC_ENABLED && key === "battery_russia") {
          return;
        }
        if (
          filters[key as keyof typeof filters].value !== 0 &&
          filters[key as keyof typeof filters].value !== false
        ) {
          const filterValue = filters[key as keyof typeof filters].value;
          const clusterValue = cluster[key as keyof typeof cluster];

          if (key === "battery_russia" || key === "battery_world") {
            if (
              normalizeBattery(String(filterValue)) !==
              normalizeBattery(String(clusterValue ?? ""))
            ) {
              isFiltered = false;
            }
            return;
          }

          if (filterValue !== clusterValue) {
            isFiltered = false;
          }
        }
      });

      if (isFiltered) return cluster;
    });
    const newObject = {...dataServer, clusters: filteredClusters};

    return newObject;
  }
};
